(function () {
  if (typeof window !== "undefined") {
    if (window.__amSplit === "litebox") return;
    window.__amSplit = "litebox";
  }

  function isShorts(media) {
    return !!(media && media.closest(".am-shorts"));
  }

  function syncPlayLabel(media) {
    var btn = media.querySelector("[data-am-video-play]");
    if (!btn) return;
    btn.setAttribute("aria-label", media.classList.contains("is-playing") ? "Pause video" : "Play video");
  }

  function playMedia(media) {
    var file = media.querySelector("video");
    var embed = media.getAttribute("data-video-embed");
    media.classList.add("is-playing");
    if (isShorts(media)) media.classList.add("is-started");
    syncPlayLabel(media);
    if (file) {
      if (isShorts(media)) {
        file.loop = true;
        file.playsInline = true;
      }
      if (!file.dataset.amEnded) {
        file.dataset.amEnded = "1";
        file.addEventListener("ended", function () {
          if (file.loop) return;
          media.classList.remove("is-playing");
          syncPlayLabel(media);
        });
      }
      var play = file.play();
      if (play && play.catch) play.catch(function () {});
      return;
    }
    if (embed && !media.querySelector("iframe")) {
      var frame = document.createElement("iframe");
      frame.className = "am-split__embed";
      frame.src = embed;
      frame.allow = "autoplay; fullscreen; picture-in-picture";
      frame.allowFullscreen = true;
      media.appendChild(frame);
      return;
    }
    media.classList.remove("is-playing");
    syncPlayLabel(media);
  }

  function pauseMedia(media) {
    var file = media.querySelector("video");
    if (file) file.pause();
    media.classList.remove("is-playing");
    syncPlayLabel(media);
  }

  function toggleMute(media, btn) {
    var file = media.querySelector("video");
    if (!file) return;
    file.muted = !file.muted;
    btn.classList.toggle("is-muted", file.muted);
    btn.setAttribute("aria-label", file.muted ? "Unmute" : "Mute");
  }

  function uniqueShorts(section) {
    var seen = {};
    var list = [];
    section.querySelectorAll(".am-people__slide [data-am-short-index]").forEach(function (media) {
      var idx = media.getAttribute("data-am-short-index");
      if (seen[idx]) return;
      seen[idx] = true;
      list.push(media);
    });
    return list;
  }

  function buildLitebox(section, box) {
    var track = box.querySelector("[data-am-litebox-track]");
    if (!track || track.childElementCount) return;
    uniqueShorts(section).forEach(function (source) {
      var slide = document.createElement("article");
      slide.className = "am-shorts-litebox__slide";
      var clone = source.cloneNode(true);
      clone.removeAttribute("data-am-short-index");
      var file = clone.querySelector("video");
      if (file) {
        file.muted = true;
        file.loop = true;
        file.playsInline = true;
        file.pause();
      }
      slide.appendChild(clone);
      track.appendChild(slide);
    });
    if (track.childElementCount < 2) box.classList.add("is-single");
  }

  function liteboxIndex(box) {
    return Number(box.dataset.index || 0);
  }

  function showLiteboxSlide(box, index) {
    var slides = box.querySelectorAll(".am-shorts-litebox__slide");
    var n = slides.length;
    if (!n) return;
    index = ((index % n) + n) % n;
    box.dataset.index = String(index);
    box.querySelector("[data-am-litebox-track]").style.transform = "translateX(" + -index * 100 + "%)";
    var active = null;
    slides.forEach(function (slide, i) {
      var media = slide.querySelector("[data-am-video]");
      if (!media) return;
      if (i === index) active = media;
      else pauseMedia(media);
    });
    if (active) playMedia(active);
  }

  function setCarouselPlaying(section, on) {
    section.querySelectorAll(".am-people__slide [data-am-video]").forEach(function (media) {
      if (on) playMedia(media);
      else pauseMedia(media);
    });
  }

  function closeLitebox(box) {
    var section = box.amSection || box.closest(".am-shorts");
    box.classList.remove("is-open");
    box.setAttribute("hidden", "");
    document.body.classList.remove("am-shorts-litebox-open");
    box.querySelectorAll("[data-am-video]").forEach(pauseMedia);
    if (section) setCarouselPlaying(section, true);
  }

  function mountLitebox(section) {
    var box = (section && section.querySelector("[data-am-litebox]")) || document.querySelector("[data-am-litebox]");
    if (!box) return null;
    document.querySelectorAll("[data-am-litebox]").forEach(function (el) {
      if (el !== box) el.remove();
    });
    if (box.parentElement !== document.body) document.body.appendChild(box);
    return box;
  }

  function openLitebox(media) {
    var section = media.closest(".am-shorts");
    if (!section) return;
    var box = mountLitebox(section);
    if (!box) return;
    box.amSection = section;
    buildLitebox(section, box);
    setCarouselPlaying(section, false);
    box.removeAttribute("hidden");
    box.classList.add("is-open");
    document.body.classList.add("am-shorts-litebox-open");
    showLiteboxSlide(box, Number(media.getAttribute("data-am-short-index") || 0));
  }

  function bindLitebox(section) {
    var box = mountLitebox(section);
    if (!box || box.dataset.amBound) return;
    box.dataset.amBound = "1";
    var view = box.querySelector("[data-am-litebox-view]");
    var startX = 0;
    box.addEventListener("click", function (event) {
      if (event.target === box) closeLitebox(box);
    });
    if (view) {
      view.addEventListener("pointerdown", function (event) {
        startX = event.clientX;
      });
      view.addEventListener("pointerup", function (event) {
        var dx = event.clientX - startX;
        if (dx > 50) showLiteboxSlide(box, liteboxIndex(box) - 1);
        else if (dx < -50) showLiteboxSlide(box, liteboxIndex(box) + 1);
      });
    }
  }

  function bindShortsPeek(section) {
    var rail = section.querySelector(".am-people__viewport") || section;
    var timer;
    function clearPeek() {
      section.querySelectorAll(".am-people__slide [data-am-video]").forEach(function (media) {
        media.classList.remove("is-peek");
      });
    }
    function peek() {
      if (document.body.classList.contains("am-shorts-litebox-open")) return;
      section.querySelectorAll(".am-people__slide [data-am-video]").forEach(function (media) {
        media.classList.add("is-peek");
      });
      clearTimeout(timer);
      timer = setTimeout(clearPeek, 1400);
    }
    rail.addEventListener("mousemove", peek);
    rail.addEventListener("mouseenter", peek);
    rail.addEventListener("mouseleave", function () {
      clearTimeout(timer);
      clearPeek();
    });
  }

  function initShorts() {
    document.querySelectorAll(".am-shorts").forEach(function (section) {
      section.querySelectorAll(".am-people__slide [data-am-video]").forEach(playMedia);
      bindShortsPeek(section);
      bindLitebox(section);
    });
  }

  function openVideoLink(media) {
    var href = media && media.getAttribute("data-href");
    if (!href) return false;
    if (/^https?:\/\//i.test(href)) {
      window.open(href, "_blank", "noopener,noreferrer");
    } else {
      window.location.href = href;
    }
    return true;
  }

  document.addEventListener("click", function (event) {
    var closeBtn = event.target.closest("[data-am-litebox-close]");
    var prevBtn = event.target.closest("[data-am-litebox-prev]");
    var nextBtn = event.target.closest("[data-am-litebox-next]");
    if (closeBtn || prevBtn || nextBtn) {
      var box = event.target.closest("[data-am-litebox]");
      if (!box) return;
      event.preventDefault();
      if (closeBtn) closeLitebox(box);
      else if (prevBtn) showLiteboxSlide(box, liteboxIndex(box) - 1);
      else showLiteboxSlide(box, liteboxIndex(box) + 1);
      return;
    }
    var playBtn = event.target.closest("[data-am-video-play]");
    var pauseBtn = event.target.closest("[data-am-video-pause]");
    var muteBtn = event.target.closest("[data-am-video-mute]");
    var fullBtn = event.target.closest("[data-am-video-full]");
    if (playBtn || pauseBtn || muteBtn || fullBtn) {
      var media = (playBtn || pauseBtn || muteBtn || fullBtn).closest("[data-am-video]");
      if (!media) return;
      event.preventDefault();
      if (muteBtn) {
        toggleMute(media, muteBtn);
        return;
      }
      if (fullBtn) {
        openLitebox(media);
        return;
      }
      if (pauseBtn || media.classList.contains("is-playing")) {
        pauseMedia(media);
        return;
      }
      playMedia(media);
      return;
    }
    var linkMedia = event.target.closest("[data-am-video][data-href]");
    if (linkMedia && !linkMedia.closest(".am-shorts-litebox")) {
      event.preventDefault();
      openVideoLink(linkMedia);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var linkMedia = event.target.closest("[data-am-video][data-href]");
    if (!linkMedia || linkMedia.closest(".am-shorts-litebox")) return;
    event.preventDefault();
    openVideoLink(linkMedia);
  });

  document.addEventListener("keydown", function (event) {
    var box = document.querySelector(".am-shorts-litebox.is-open");
    if (!box) return;
    if (event.key === "Escape") closeLitebox(box);
    else if (event.key === "ArrowLeft") showLiteboxSlide(box, liteboxIndex(box) - 1);
    else if (event.key === "ArrowRight") showLiteboxSlide(box, liteboxIndex(box) + 1);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShorts);
  } else {
    initShorts();
  }
})();
